import { JSX } from "react";
import { formatUnconvertedDateCustom } from "@app/shared/formatDateTime";
import { Attestation } from "@app/tools/accuracy-evidence/models/attestation";

interface QdpAttestorDetailsPanelProps {
  attestation: Attestation;
}

function dashed(value: string) {
  return value || "--";
}

export default function QdpAttestorDetailsPanel(props: QdpAttestorDetailsPanelProps): JSX.Element {
  return (
    <>
      <div className="card">
        <ul className="list-group list-group-flush">
          <li className="list-group-item bordered evidence-header">
            <div className="col-6 text-end"><b>Item</b></div>
            <div className="col-6"><b>Value</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Outreach Method</b></div>
            <div className="col-6"><b>{dashed(props.attestation.OutreachMethod)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Attestation Method</b></div>
            <div className="col-6"><b>{dashed(props.attestation.ValidationMethod)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Roster Name</b></div>
            <div className="col-6"><b>{dashed(props.attestation.RosterName)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Publisher</b></div>
            <div className="col-6"><b>{dashed(props.attestation.Publisher)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Attester Full Name</b></div>
            <div className="col-6"><b>{dashed(props.attestation.AttestorName)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Attester Email</b></div>
            <div className="col-6"><b>{dashed(props.attestation.EmailAddress)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Attester Phone</b></div>
            <div className="col-6"><b>{dashed(props.attestation.PhoneNumber)}</b></div>
          </li>
          <li className="list-group-item bordered">
            <div className="col-6 text-end"><b>Date of Attestation</b></div>
            <div className="col-6"><b>{dashed(formatUnconvertedDateCustom(props.attestation.AttestationDate, "L"))}</b></div>
          </li>
        </ul>
      </div>
    </>
  );
}